
import type { App } from 'vue';
import { loadScript } from '../helpers/load';

export function gtag(...args: any[]) {
  // @ts-expect-error: dataLayer can be injected by GTM
  window.dataLayer = window.dataLayer || [];
  // @ts-expect-error: dataLayer can be injected by GTM
  window.dataLayer.push(args);
}

const plugin = {
  install: function (app: App, options: { gtagId: string }): void {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${options.gtagId}`).then(() => {
      // console.log('GTAG script loaded successfully', options.gtagId);
      // @ts-expect-error: dataLayer can be injected by GTM
      window.dataLayer = window.dataLayer || [];
      gtag('js', new Date());
      gtag('config', options.gtagId);
      app.config.globalProperties.$gtag = gtag;
    }).catch((error) => {
      console.error('Error loading GTAG script:', error);
    });
  },
};

export default plugin;
